// extracted by mini-css-extract-plugin
module.exports = {"schoolsWrap":"trusted-by-schools-section_schoolsWrap__FKKAS"};